export default `
-- AlterTable
ALTER TABLE "File" ADD COLUMN "earliest_known_modified_at" DATETIME;
`;
